import {apiFetch} from "../../../../actions/apiActions";
import {toast} from "react-toastify";
import {encodeParams, makeActionCreator} from "../../../../utils";
import moment from "moment/moment";
import download from "downloadjs";
import {customerViewFiltersSelector} from "../../../CustomerPanelPage/actions/customerPanelExternalsActions";
import {PERMISSION_CLIENT_PANEL} from "../../../../../../common/src/permissions";
export const DASHBOARD_IS_LOADING = "DASHBOARD_IS_LOADING";
export const DASHBOARD_DATA_UPDATE = "DASHBOARD_DATA_UPDATE";
export const DASHBOARD_PERIOD_UPDATE = "DASHBOARD_PERIOD_UPDATE";
export const DASHBOARD_RANGE_UPDATE = "DASHBOARD_RANGE_UPDATE";
export const DASHBOARD_PERIOD_NAME_UPDATE = "DASHBOARD_PERIOD_NAME_UPDATE";
export const DASHBOARD_CHART_IS_LOADING = "DASHBOARD_CHART_IS_LOADING";
export const DASHBOARD_CHART_DATA_UPDATE = "DASHBOARD_CHART_DATA_UPDATE";
export const DASHBOARD_CHART_CUSTOMIZER_DATA_UPDATE = "DASHBOARD_CHART_CUSTOMIZER_DATA_UPDATE";
export const DASHBOARD_TABLE_DATA_LOADING = "DASHBOARD_TABLE_DATA_LOADING";
export const DASHBOARD_TABLE_DATA_UPDATE = "DASHBOARD_TABLE_DATA_UPDATE";
export const DASHBOARD_CUSTOMIZER_UPDATE = "DASHBOARD_CUSTOMIZER_UPDATE";
export const DASHBOARD_HAS_ACTIVE_USER_UPDATE = "DASHBOARD_HAS_ACTIVE_USER_UPDATE";
export const DASHBOARD_PARTS_SELECTED_UPDATE = "DASHBOARD_PARTS_SELECTED_UPDATE";
export const DASHBOARD_DATA_LOADED = "DASHBOARD_DATA_LOADED";

const setDashboardLoading = makeActionCreator(DASHBOARD_IS_LOADING, "payload");
const setDashboardDataUpdate = makeActionCreator(DASHBOARD_DATA_UPDATE, "payload");
const setDashboardChartLoading = makeActionCreator(DASHBOARD_CHART_IS_LOADING, "payload");
const setDashboardChartDataUpdate = makeActionCreator(DASHBOARD_CHART_DATA_UPDATE, "payload");
const setDashboardChartCustomizerDataUpdate = makeActionCreator(DASHBOARD_CHART_CUSTOMIZER_DATA_UPDATE, "payload");
const setDashboardTableDataLoading = makeActionCreator(DASHBOARD_TABLE_DATA_LOADING, "payload");
const setDashboardTableDataUpdate = makeActionCreator(DASHBOARD_TABLE_DATA_UPDATE, "payload");
const setDashboardDataLoaded = makeActionCreator(DASHBOARD_DATA_LOADED, "payload");

export const setPeriod = makeActionCreator(DASHBOARD_PERIOD_UPDATE, "payload");
export const setDateRange = makeActionCreator(DASHBOARD_RANGE_UPDATE, "payload");
export const setPeriodName = makeActionCreator(DASHBOARD_PERIOD_NAME_UPDATE, "payload");
export const setDashboardCustomizerUpdate = makeActionCreator(DASHBOARD_CUSTOMIZER_UPDATE, "payload");
export const setDashboardHasActiveUserUpdate = makeActionCreator(DASHBOARD_HAS_ACTIVE_USER_UPDATE, "payload");
export const setSelectedParts = makeActionCreator(DASHBOARD_PARTS_SELECTED_UPDATE, "payload");
export const updateCustomizationFilter = (key, filterData) => ({
    type: 'CUSTOMIZATION_FILTER_UPDATE',
    payload: { key, filterData }
});
export function setOrderCustomization(id, employeeId) {
    return async (dispatch, getState) => {
        const customizations = getState().clientPanel.detailsPageReducer.customizations;
        const userHasClientPanelPermissions = getState().auth.user.group.permissions.indexOf(PERMISSION_CLIENT_PANEL) !== -1;
        if(id && !userHasClientPanelPermissions) {
            try {
                let resp = await dispatch(
                    apiFetch(`/api/orders/${id}/customizations`, {
                        method: "PUT",
                        body: JSON.stringify({
                            customizations
                        })
                    })
                );
                let data = await resp.json();
                if (resp.status !== 200) {
                    throw new Error(data.message || "Unknown error");
                }
            } catch (e) {
                toast(e.message, {type: "error"});
            }
            if(id !== employeeId) {
                //aktualizacja wyłącznie dla symulacji dla danego urzytkownika (po employeeId)
                try {
                    let resp = await dispatch(
                        apiFetch(`/api/users/employee/${employeeId}/customizations/order/${id}`, {
                            method: "PUT",
                            body: JSON.stringify({
                                customizations
                            })
                        })
                    );
                    let data = await resp.json();
                    if (resp.status !== 200) {
                        throw new Error(data.message || "Unknown error");
                    }
                } catch (e) {
                    toast(e.message, {type: "error"});
                }
            }

        }
        if(userHasClientPanelPermissions) {
            try {
                let resp = await dispatch(
                    apiFetch(`/api/users/${getState().auth.user._id}/customizations/order/${id}`, {
                        method: "PUT",
                        body: JSON.stringify({
                            customizations
                        })
                    })
                );
                let data = await resp.json();
                if (resp.status !== 200) {
                    throw new Error(data.message || "Unknown error");
                }
            } catch (e) {
                toast(e.message, {type: "error"});
            }
        }
    }
}


export function getOrder(order) {
    return async (dispatch) => {
        dispatch(setDashboardLoading(true));
        try {
            let orderInformation = await dispatch(apiFetch(encodeParams`/api/customer-panel/orders/${order}/dashboard`));
            let orderInformationData = await orderInformation.json();

            if (!orderInformation.ok) {
                throw new Error(orderInformationData.message);
            }
            dispatch(setDashboardDataUpdate(orderInformationData))
            dispatch(setDashboardHasActiveUserUpdate(orderInformationData.hasActiveUser))
            if(orderInformationData.lastSearch) {
                dispatch(setSelectedParts(orderInformationData.lastSearch.parts))
                dispatch(setDateRange({start: orderInformationData.lastSearch.dateStart, end: orderInformationData.lastSearch.dateEnd}))
            }
            dispatch(setDashboardDataLoaded(true));
            dispatch(setDashboardLoading(false));
        }
        catch (e) {
            toast(e.message, {type: 'error'});
        }
    }
}

export function getCustomization(order, employeeId) {
    return async (dispatch, getState) => {
        dispatch(setDashboardLoading(true));
        if(!employeeId) {
            if(getState().auth.authState === "STATE_LOADING") {
                const checkInterval = setInterval(() => {
                }, 1000);
                return ()=> clearInterval(checkInterval);
            }
        }
        try {
            let customizer = await dispatch(apiFetch(encodeParams`/api/customer-panel/orders/${order}/customization/${employeeId}`));
            let customizerData = await customizer.json();
            dispatch(setDashboardCustomizerUpdate(customizerData.customizations))
            dispatch(setDashboardLoading(false));
        }
        catch (e) {
            toast(e.message, {type: 'error'});
        }
    }
}

export function getOrderChart(orderId) {
    return async (dispatch, getState) => {
        const range = getState().clientPanel.detailsPageReducer.range;
        dispatch(setDashboardChartLoading(true));
        try {
            let orderChart = null;
            if(getState().router.location.pathname.indexOf('/customer/dashboard/') === -1) { //simulation view
                let customerId = getState().router.location.pathname.split('/')[2];
                orderChart = await dispatch(apiFetch(encodeParams`/api/customer-panel/orders/${orderId}/chart/${customerId}?start=${range.start}&end=${range.end}`));
            } else { //customer view
                orderChart = await dispatch(apiFetch(encodeParams`/api/customer-panel/orders/${orderId}/chart?start=${range.start}&end=${range.end}`));
            }
            let orderChartData = await orderChart.json();

            if (!orderChart.ok) {
                throw new Error(orderChartData.message);
            }
            dispatch(setDashboardChartDataUpdate(orderChartData.data))
            dispatch(setDashboardChartLoading(false));
        }
        catch (e) {
            toast(e.message, {type: 'error'});
        }
    }
}

export function getOrderTable(order) {
    return async (dispatch, getState) => {
        const range = getState().clientPanel.detailsPageReducer.range;
        dispatch(setDashboardTableDataLoading(true));
        try {
            const filtersSelectedParts = getState().clientPanel.detailsPageReducer.selectedParts;
            //new general summary
            let dateStart = (range && range.start) ? new Date(range.start) : new Date()
            if (isNaN(dateStart.getTime())) {
                dateStart = new Date();
            }
            let dateEnd = (range && range.end) ? new Date(range.end) : new Date()
            if (isNaN(dateEnd.getTime())) {
                dateEnd = new Date();
            }

            const baseUrl = encodeParams`/api/customer-panel/externals/part-report?order=${order}&dateStart=${dateStart}&dateEnd=${dateEnd}`;
            const partNumberParams = filtersSelectedParts.map(f => `&partNumber=${encodeURIComponent(f)}`).join('');
            const finalUrl = baseUrl + partNumberParams;
            let generalSummaryPerPart = await dispatch(
                apiFetch(
                    finalUrl
                )
            );
            let generalSummaryPerPartData = await generalSummaryPerPart.json();

            if (!generalSummaryPerPart.ok) {
                throw new Error(generalSummaryPerPartData.message);
            }

            //new working hours
            let workingHours = await dispatch(
                apiFetch(
                    encodeParams`/api/customer-panel/externals/hour-report?order=${order}&dateStart=${range.start}&dateEnd=${range.end}`
                )
            );
            let workingHoursData = await workingHours.json();
            if (!workingHours.ok) {
                throw new Error(workingHoursData.message);
            }


            //new details part report
            const customizations = getState().clientPanel.detailsPageReducer.customizations;
            let customizerHoursTableRow = customizations[customizations.findIndex(el => el.title === "Hours table")];
            const hoursTable = `&hoursTable=${customizerHoursTableRow.enabled}`
            const baseUrlDetailedPart = encodeParams`/api/customer-panel/externals/detail-part-report?order=${order}&dateStart=${range.start}&dateEnd=${range.end}`;
            const partNumberParamsDetailedPart = filtersSelectedParts.map(f => `&partNumber=${encodeURIComponent(f)}`).join('');
            const finalUrlDetailedPart = baseUrlDetailedPart + partNumberParams + hoursTable;
            let detailedPartReport = await dispatch(
                apiFetch(
                    finalUrlDetailedPart
                )
            );
            let detailedPartReportData = await detailedPartReport.json();
            if (!detailedPartReport.ok) {
                throw new Error(detailedPartReportData.message);
            }

            //new daily part report
            const baseUrlDailyPart = encodeParams`/api/customer-panel/externals/daily-part-report?order=${order}&dateStart=${range.start}&dateEnd=${range.end}`;
            const partNumberParamsDailyPart = filtersSelectedParts.map(f => `&partNumber=${encodeURIComponent(f)}`).join('');
            const finalUrlDailyPart = baseUrlDailyPart + partNumberParams + hoursTable;

            let dailyPartReport = await dispatch(
                apiFetch(
                    finalUrlDailyPart
                )
            );
            let dailyPartReportData = await dailyPartReport.json();
            if (!detailedPartReport.ok) {
                throw new Error(dailyPartReportData.message);
            }

            //description for NOK's detail
            let letterColumnsDescription = await dispatch(
                apiFetch(encodeParams`/api/customer-panel/orders/${order}/letter-columns-desc`)
            );
            let letterColumnsDescriptionData = await letterColumnsDescription.json();
            if (!letterColumnsDescription.ok) {
                throw new Error(letterColumnsDescriptionData.message);
            }

            let tableData = {
                generalSummaryPerPart: generalSummaryPerPartData,
                workingHours: workingHoursData,
                detailedPartReport: detailedPartReportData,
                dailyPartReport: dailyPartReportData,
                letterColumnsDescription: letterColumnsDescriptionData
            };
            dispatch(setDashboardTableDataUpdate(tableData));
            dispatch(setDashboardChartCustomizerDataUpdate(
                {
                    ...filterObjectByKeys(detailedPartReportData, ['chartReworkedData', 'chartNOKData', 'chartOKNOKData', 'chartOKReworkData', 'chartParetoNOKData', 'chartParetoReworkedData', 'chartParetoNOKandReworkedData', 'chartParetoPartReworkNOKData', 'analysisDays']),
                    ...filterObjectByKeys(dailyPartReportData, ['chartNOKDayData', 'chartReworkDayData', 'chartTotalCheckedPartDayData', 'chartHoursData'])
                }));
            dispatch(setDashboardTableDataLoading(false));

        } catch (e) {
            toast(e.message, {type: 'error'});
        }
    }
}

export function generateCustomerReport(orderId) {
    return async (dispatch, getState) => {
        try {
            const range = getState().clientPanel.detailsPageReducer.range;
            let resp = await dispatch(
                apiFetch("/api/customer-panel/externals/generate-excel", undefined, {
                    dateStart: moment(range.start).format("YYYY-MM-DD"),
                    dateEnd: moment(range.end).format("YYYY-MM-DD"),
                    order: orderId
                })
            );
            if (resp.status !== 200) {
                throw new Error((await resp.json()).message);
            }

            let data = await resp.blob();
            download(data);
        } catch (e) {
            toast(e.message, { type: "error" });
        }
    };
}

/**
 * Filtruje obiekt według podanych kluczy - wersja jako funkcja
 * @param {Object} obj - Obiekt do filtrowania
 * @param {Array} keys - Tablica kluczy do zachowania
 * @returns {Object} Nowy obiekt zawierający tylko wybrane klucze
 */
const filterObjectByKeys = (obj, keys) => {
    return Object.fromEntries(
        Object.entries(obj).filter(([key]) => keys.includes(key))
    );
};